import { reloadGuard } from './reload-guard.js';

/**
 * Heap budget izleyici — bellek sızıntısı durumunda kontrollü soft reload.
 *
 * performance.memory yalnız Chromium'da. Hedef cihazlar Chromium tabanlı
 * (TV Chrome / RPi Chromium); başka tarayıcıda sessizce devre dışı kalır.
 *
 * Memory: decision_pwa_resilience.md §4
 */
interface PerformanceMemory {
    usedJSHeapSize: number;
    totalJSHeapSize: number;
    jsHeapSizeLimit: number;
}

const HEAP_BUDGET_MB = 200;
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

let monitorTimer: number | null = null;

function readMemory(): PerformanceMemory | null {
    if (!('memory' in performance)) return null;
    return (performance as unknown as { memory: PerformanceMemory }).memory;
}

export function getCurrentMemoryMb(): number {
    const mem = readMemory();
    if (!mem) return 0;
    return mem.usedJSHeapSize / (1024 * 1024);
}

export function startMemoryMonitor(): void {
    if (monitorTimer !== null) return;
    if (!readMemory()) {
        console.warn('[memory-monitor] performance.memory desteklenmiyor — devre dışı');
        return;
    }

    monitorTimer = window.setInterval(() => {
        const usedMb = getCurrentMemoryMb();
        if (usedMb > HEAP_BUDGET_MB) {
            console.warn(
                `[memory-monitor] heap ${usedMb.toFixed(1)}MB > ${HEAP_BUDGET_MB}MB — soft reload`,
            );
            reloadGuard.requestReload(`memory_${usedMb.toFixed(0)}mb`);
        }
    }, CHECK_INTERVAL_MS);

    console.info('[memory-monitor] başlatıldı (5dk kontrol / 200MB bütçe)');
}

export function stopMemoryMonitor(): void {
    if (monitorTimer !== null) {
        clearInterval(monitorTimer);
        monitorTimer = null;
    }
}
